import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'
import { type FC, type PropsWithChildren } from 'react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Media from '@segment/matcha/components/Media'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import NavigationBrand from '@segment/templates/NavigationBrand'

import FooterCompact from '@segment/templates/FooterCompact'

import Layout from '@segment/next-shared/layout'

import OurTake from './components/OurTake'
import Methodology from './components/Methodology'
import Hero from './components/Hero'
import Introduction from './components/Introduction'
import KeyFindings from './components/KeyFindings'
import SignUp from './components/Signup'

import SectionNav from './components/SectionNav'

import MobileSelect from './components/MobileSelect'

import ogImagePng from './assets/OgGrowthReport.png'

const TheGrowthReportView: FC<PropsWithChildren> = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="The Growth Report: The AI Edition | Twilio Segment"
        pageDescription="Twilio Segment’s third annual Growth Report is a yearly exploration of the tools, technology, and techniques businesses are using to grow in 2023."
        pageOG={ogImagePng}
        themeColor={theme.palette.neutrals.white[100]}
        bodyBackground={theme.palette.neutrals.white[100]}
      >
        <NavigationBrand />
        <Main>
          <Background>
            <Hero />
            <StyledSection variant="sidebar" sidebarSize="small" sticky={true}>
              <Media greaterThanOrEqual="xl">
                <SectionNav />
              </Media>
              <Media lessThan="xl">
                <MobileSelect />
              </Media>
              <Section.Contents>
                <Introduction />
                <KeyFindings />
                <OurTake />
                <SignUp />
                <Methodology />
              </Section.Contents>
            </StyledSection>
          </Background>
        </Main>
        <FooterCompact divider={true} backgroundColor={theme.palette.neutrals.white[100]} />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main``

const Background = styled.div`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

const StyledSection = styled(SectionBase)`
  ${Section.Sticky} {
    top: 144px;
  }
`

export default TheGrowthReportView
